module.exports = __webpack_public_path__ + "img/partner-themangrove.853ec305.png";